// extracted by mini-css-extract-plugin
export default {"price":"Exchange_price__OMVgL","pTable":"Exchange_pTable__rBM0G"};